<template>
	<div class="faq-container">
		<div class="faq-header">{{ $t('安卓客户端常见问题及处理方式：') }}</div>
		<div class="faq-content">{{ $t('一、无法连接，请排查下面的配置：') }}</div>
		<div class="faq-content">{{ $t('1、 在系统设置中找到启动管理 → 应用启动管理，关闭加速器App的自动管理开关，并在弹窗中勾选允许后台活动；') }}</div>
		<div class="faq-content">{{ $t('2、 在设置 → 电池 → 耗电排行榜 → 星云 → 应用启动管理中，开启"允许后台活动"；') }}</div>
		<div class="faq-content">{{ $t('3、 在设置 → 应用 → 应用管理 → 星云加速 → 所有权限中查看"创建VPN"权限是否打开；') }}</div>
		<div class="faq-content">{{ $t('4、 如果上述设置后都无效，请重装应用。') }}</div>
		<div class="faq-header">{{ $t('二、华为鸿蒙系统无法连接：') }}</div>
		<div class="faq-content">{{ $t('1、 允许应用后台运行：进入设置 → 搜索进入 应用启动管理 → 关闭"星云加速器"的自动管理开关 → 在弹框中勾选允许后台活动；') }}</div>
		<div class="faq-content">{{ $t('2、 避免应用被电池优化程序清理：进入设置 → 搜索进入电池优化 → 不允许 → 选择所有应用 → 找到无法后台运行的应用 → 设置为不允许；') }}</div>
		<div class="faq-content">{{ $t('3、 关闭省电模式：进入设置 → 电池 → 关闭 省电模式开关；') }}</div>
		<div class="faq-content">{{ $t('4、 保持设备网络连接：进入设置  → 电池 → 更多电池设置 → 开启 休眠时始终保持网络连接开关；') }}</div>
		<div class="faq-content">{{ $t('5、 给后台运行的应用加锁：打开应用后 → 进入多任务界面 → 下拉选中的卡片进行加锁 → 然后点击清理图标清理其他不经常使用的应用；') }}</div>
		<div class="faq-content">{{ $t('6、 设置开发人员选项中相关开关：进入设置 → 搜索进入开发人员选项 → 找到不保留活动开关后关闭 → 并在后台进程限制选择标准限制；') }}</div>
		<div class="faq-header">{{ $t('三、访问谷歌google.com后重定向到google.cn/m：') }}</div>
		<div class="faq-content">{{ $t('更改访问域名为google.com/ncr；') }}</div>
		<div class="faq-header">{{ $t('四、退出后自动登出：') }}</div>
		<div class="faq-content">{{ $t('这种情况应该是在加载节点的时候退出了应用。这是一项保护机制，请尽量不要在加载节点时退出。') }}</div>
	</div>
</template>
<script>
export default {
	name: "FaqPage",
	components: {},
	data() {
		return {}
	},
	methods: {
		onRedirect(url) {
			if (window.Android && typeof window.Android.onEvent === 'function') {
				// 触发自定义事件
				window.Android.onEvent('openBrowser', JSON.stringify({url: url}));
			} else {
				window.open(url, '_blank');
			}
		}
	}
}
</script>

<style scoped>
.faq-container {
	display: flex;
	flex-direction: column;
	align-items: start;
	color: #E6D5B8;
	padding: 0.4em;
	box-sizing: border-box;
}


.faq-header {
	font-size: 1.4em;
	line-height: 1.4em;
	font-weight: bold;
	margin-top: 1em;
	text-align: start;
}


.faq-content {
	text-align: start;
	font-size: 1.2em;
	line-height: 1.4em;
}
</style>